import type { FaireProductEntity } from "../../entity_types/product";

export const p_6n73fxvx6y: FaireProductEntity = {
  token: "p_6n73fxvx6y",
  type: "product",
  name: "475BK Darci Dress 3",
  brandToken: "b_m84sdvbj3h",
  brandName: "AEMI + CO",
  imageUrl:
    "https://cdn.faire.com/fastly/eba1aecd8c745b8311b8703c9afecc0408203ab78ef7a3590724ead63e549cc2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4aa7e42873f1e7152d14e2ff5d23cf372160dfc1a31a90e5b3f57aca6af33dd1.jpeg",
    "https://cdn.faire.com/fastly/5c68934d59ef6ded5ec95fc04a1c055c871350a0fbe3dd431ff485f64f12b951.jpeg",
    "https://cdn.faire.com/fastly/8ce4b5c260152804570803fecfece7367fa6635284550cde513d07c8d0bb2e3b.jpeg",
    "https://cdn.faire.com/fastly/20e564af22929a79d3bdd9cdf137159dc0a2e12fde14dca384d7c39f9e2decf5.jpeg",
    "https://cdn.faire.com/fastly/8e05cf6c8a7ff5eef05897f7c304a0bfba33ed25698c003258dd8900d5cf473e.jpeg",
    "https://cdn.faire.com/fastly/b613b7eda0bce0d2d799f0f4a972ee7bf23da82b05f85b51a3b2a07f296bfcf1.jpeg",
    "https://cdn.faire.com/fastly/7e506e708e85d92698c100ac7f7184f0f3833cc6df460f440d03b7d191670123.jpeg",
    "https://cdn.faire.com/fastly/eabbb56df7a6406d7da395c06c1d38e852d7e19bc4ab04344141fd8c414b96c1.jpeg",
    "https://cdn.faire.com/fastly/734f3afa4d9e945d99c4f8cd8d034d5d574953435c472fa6ddcddf93c3b16039.jpeg",
    "https://cdn.faire.com/fastly/817ff9b05c7dde1bb815f5897976c03a754eca0178a85e2081a4a7b57d8de313.jpeg",
    "https://cdn.faire.com/fastly/eb8c1ddc680bb24f629f927bcbda1c0cf5f6f5a8808489acb8a559ea07d2cc84.jpeg",
    "https://cdn.faire.com/fastly/49010b7be9ff8ebf9305c5c88eb856e83e35521eb4eac4ea944a2eb19c4bdbe7.jpeg",
    "https://cdn.faire.com/fastly/57607a917320225b2a2d0c450db720c85324eb53549d11f52ca6a62ecff5e462.jpeg",
    "https://cdn.faire.com/fastly/b26f674748111cc27081acf661ed5f6333df8e812ae0a05ba415d8f5bf108d95.jpeg",
    "https://cdn.faire.com/fastly/1722d8225afc3ab943c0e21ea9e213580324751bfd52ba51c9e6cd6c0b3cc81d.jpeg",
    "https://cdn.faire.com/fastly/ce66dfa06b00e1b1060627f17731454ff992a3abe69ea0cd9e4ae63eadcd8cec.jpeg",
    "https://cdn.faire.com/fastly/ca1d5e681025f893c1899ae34a7ac41901a10a5a32684c1144f187331639dc5f.jpeg",
    "https://cdn.faire.com/fastly/9c30b01abdaea6804024d8567b705afdc59cd8ce47c943c8bbbb4584ccfef745.jpeg",
    "https://cdn.faire.com/fastly/f805a348fa6be49338c588d3f35e1f740674f93fcd8d7d6680fe64ac2ae7ea4c.jpeg",
    "https://cdn.faire.com/fastly/dd93576730e0f2c88fa8f6eb28c1170a0f414649d010e7b08a36831d9f203d7d.jpeg",
    "https://cdn.faire.com/fastly/37c5bbecc01fb9944edd6222cd9c92ee1a919d437f8656aa798e4c95ce724753.jpeg",
    "https://cdn.faire.com/fastly/017afbd4f54273729a2cfce903f8d8491e1ae24f71fc728d45fccee767914a46.jpeg",
    "https://cdn.faire.com/fastly/bf52fb11411762b422ecade3a926c84fc24edcf050b39050d1bac62daabb60e7.jpeg",
    "https://cdn.faire.com/fastly/8231f02ae98e25a2b81ddf457ad3f0eb6f1a061f55e05e3ed03dfc0cd01bb6e1.jpeg",
    "https://cdn.faire.com/fastly/bd9ec33eede4e7b664dfbb3e64c0c55cc6ed8b3b178d7b7d7c734e880148a3f2.jpeg",
    "https://cdn.faire.com/fastly/a7ae3c5f654c784507902cda7db1d76e2bdb378223e093791279976a484ca651.jpeg",
    "https://cdn.faire.com/fastly/30c173b3f4dabda11907116eb894ba68e9f97e91794940c5f9609e6df6abc756.jpeg",
    "https://cdn.faire.com/fastly/b968cec4b83ec51f71894616406e80bf845b504ff38426ff859d5681d351eaf5.jpeg",
    "https://cdn.faire.com/fastly/7e13cb4c3641ef509e737c74cd73c2aad93282e5178ef414f8ee3d65969152bf.jpeg",
    "https://cdn.faire.com/fastly/018e059139bd769700df2f857b05ec5f2e6b36b215d6be718924a4c3e2ade94a.jpeg",
    "https://cdn.faire.com/fastly/5e4c95bd46a7fcc398cd671804cf7aeae7e38d5997159ea190ae100f95f90a2e.jpeg",
    "https://cdn.faire.com/fastly/f16eaca8443540e89a7607b0f64ea0dc3aa8e433d80a5a14f2518903d2d23c4e.jpeg",
    "https://cdn.faire.com/fastly/6e2a9d6bc0ac902c4281aa628b24023daab0765ec57177892ab9a61674062d29.jpeg",
    "https://cdn.faire.com/fastly/a109cfe221f2f0c5137be81aad9b0e8834e8a6e2d3691814ca360c3b7416bcf7.jpeg",
    "https://cdn.faire.com/fastly/33031ca2dbd7e0d20cc6f4335d3407c58caeeeabd0dda1aa6ebfeec75bf93981.jpeg",
    "https://cdn.faire.com/fastly/c9728024a5d2e3bbc18874d7dbd811ae9ce4c1665f5952d3599c65105021eea4.jpeg",
    "https://cdn.faire.com/fastly/e924391c7dab6a2ae144b6af0a6f60b4b831cb4a0f62d980117db4a51a63718e.jpeg",
    "https://cdn.faire.com/fastly/1200a451110caf174edfa6c00284c7854c15a3d1c60eeca854e97d26d4bb95cb.jpeg",
    "https://cdn.faire.com/fastly/a0e92bbd196cfe1dd511f147503c7f6247fbce810f12920e2172da5cd1ad0d51.jpeg",
    "https://cdn.faire.com/fastly/db198ec810ec8e58082f2718c09cea4ad79b9b92842a47bb0ad523239983fb77.jpeg",
    "https://cdn.faire.com/fastly/539fc8afc3d1c22e91a081da25e1e9b5027295ff875d2b462603c678942c4bd9.jpeg",
    "https://cdn.faire.com/fastly/681b0e881d20ebb37b3fcf737e3a53e8d3db4a2ad100c1e0c575e994825fb831.jpeg",
    "https://cdn.faire.com/fastly/590873fc6a141bd44304c772e452b928685bec6ec98529242bc73bf5e2202b3b.jpeg",
    "https://cdn.faire.com/fastly/0fd49c77cf6f1613ff71e81d55ba96f20c05a12a731f517936197e572b9a012b.jpeg",
    "https://cdn.faire.com/fastly/b3b6b8c8ed56caef517d759588a8a75ee37a388d6623aab3cc3e18b2b6526974.jpeg",
    "https://cdn.faire.com/fastly/1cb12f6baf18ddafaf118d5c2383a9b130893226c803805e60b3197924fbbb61.jpeg",
    "https://cdn.faire.com/fastly/7649aa2828d1379c0cff1eff9720a60bf94327d96c54021612e8aa4a9e317d13.jpeg",
    "https://cdn.faire.com/fastly/2e67e3108aa5c70a83fc3ad5fceae792dc65f211b06cc6a33cfd1594f6b52bf6.jpeg",
    "https://cdn.faire.com/fastly/0aba70a4429a25cf1432fca1c3dfa3f8b2b3c5473e8d06bd18d7f51684b2330e.jpeg",
    "https://cdn.faire.com/fastly/789c4b0b6f4c65a3a5ed2b692f93e48daf4b16d84af899767f3c572163c67779.jpeg",
  ],
  priceDollars: 21.95,
  description:
    "Darci is the perfect gauzy cotton midi dress for this season features a cut-out at the back that can be worn reversed.",
  tags: [],
  msrpDollars: 43.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:58.662Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
